import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import AccessList from "../Components/Access List/listAccess";

const AccessListRoutes = () => {
//   const { admin } = useSelector((state) => state.admin || {});
  const currentRole = useSelector((state) => state?.admin?.admin?.data?.role)

//   const accessCode = admin?.data?.access_code || [];

//   const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
//   const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');
  return (
    <Routes>
      <Route path="/access_list" element={
          currentRole === "super_admin"
            ? <AccessList />
            : <Navigate to="/dashboard" replace />
        }></Route>
    </Routes>
  );
};

export default AccessListRoutes;
